import apiRoutes from './api.routes';
import api from './api.service';
import ModelService from './model.service';

const FeedbackService = new ModelService(apiRoutes.feedbacks, '/feedback', 'feedback');

FeedbackService.STATUS_IDEA = 1;
FeedbackService.STATUS_PLANNED = 2;
FeedbackService.STATUS_IN_PROGRESS = 3;
FeedbackService.STATUS_DONE = 4;


FeedbackService.getStatusList = t => ({
  [FeedbackService.STATUS_IDEA]: t('Idea'),
  [FeedbackService.STATUS_PLANNED]: t('Planned'),
  [FeedbackService.STATUS_DONE]: t('Done'),
  [FeedbackService.STATUS_IN_PROGRESS]: t('In progress'),
});

FeedbackService.getEmptyList = t => ({
  empty1: t('Empty Option 1'),
  empty2: t('Empty Option 2'),
});

FeedbackService.modelName = 'Feedback';


FeedbackService.getData = params => api.catchError(async () => {
  const { data, headers: { 'x-total-count': count } } = await api.get(`${apiRoutes.feedbacks}`, params);
  return { data, count: parseInt(count, 10) };
});

FeedbackService.getStatusOptions = t => FeedbackService
  .prepareOptionsFromSimpleObject(FeedbackService.getStatusList(t));

FeedbackService.getStatusTitle = (status, t) => {
  const label = FeedbackService.getStatusList(t)[status];
  return label || '-';
};

export default FeedbackService;



// WEBPACK FOOTER //
// ./src/services/feedback.service.js